export default __webpack_public_path__ + "static/media/ic-star-fill.3187408f.svg";